import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api, buildImageUrl } from '../services/api';

const Container = styled.div`
  border: 2px dashed #ddd;
  border-radius: 4px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: #007bff;
  }
`;

const Input = styled.input`
  display: none;
`;

const Label = styled.label`
  display: block;
  cursor: pointer;
  color: #666;
`;

const Preview = styled.img`
  max-width: 100%;
  max-height: 200px;
  margin-top: 1rem;
  border-radius: 4px;
`;

interface ImageUploadProps {
  onUpload: (url: string) => void;
  id?: string;
  currentImage?: string;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ onUpload, id = 'image-upload', currentImage }) => {
  const [preview, setPreview] = useState<string | null>(
    currentImage ? buildImageUrl(currentImage) : null
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPreview(currentImage ? buildImageUrl(currentImage) : null);
  }, [currentImage]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/storage/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const imageUrl = response.data.url;
      const fullImageUrl = buildImageUrl(imageUrl);
      setPreview(fullImageUrl);
      onUpload(imageUrl); // Mantém a URL relativa para salvar no banco
    } catch (error) {
      console.error('Erro ao fazer upload da imagem:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Input
        type="file"
        id={id}
        accept="image/*"
        onChange={handleFileChange}
        disabled={loading}
      />
      <Label htmlFor={id}>
        {loading ? 'Enviando...' : 'Clique para fazer upload de uma imagem'}
      </Label>
      {preview && <Preview src={preview} alt="Preview" />}
    </Container>
  );
};

export default ImageUpload; 
 